import { localizePrizeLabel } from '~/utils/formatPrize.ts'

/**
 * Enriches each prize entry with French and Portuguese localised prize labels
 * (`prize_label_fr`, `prize_label_pt`) derived from the raw `prize_label` field.
 * @param {any[]} lotteries - Raw result entries from the API.
 */
export const mapperLotteries = (lotteries) => {
	if (!lotteries || !Array.isArray(lotteries)) return
	if (lotteries.length === 0) return lotteries
	const result = lotteries.map((lottery) => {
		const lotteryContent = {
			prize_label_fr: localizePrizeLabel(lottery.prize_label, 'fr'),
			prize_label_pt: localizePrizeLabel(lottery.prize_label, 'pt'),
			...lottery,
		}
		return lotteryContent
	})
	return result
}
